import type { Translations } from '../../../types'

const profileHeroMessages: Translations = {
  "profile.hero.heading": "Profilo amministratore",
  "profile.hero.lastAccess": "Ultimo accesso",
  "profile.hero.registeredIp": "IP registrato",
  "profile.hero.roles": "Ruoli",
  "profile.hero.logout": "Logout",
  "profile.hero.logoutAction": "Esci dal backoffice",
  "profile.hero.twoFactor": "Stato 2FA",
  "profile.hero.twoFactorEnabled": "2FA attiva",
  "profile.hero.twoFactorDisabled": "2FA non attiva",
  "profile.hero.role.superAdmin": "SUPER ADMIN",
  "profile.hero.lastDevice": "Ultimo dispositivo",
  "profile.hero.estimatedLocation": "Posizione stimata",
  "profile.hero.trustedSessions": "Sessioni fidate",
  "profile.hero.unknown": "N/D",
}

export default profileHeroMessages
